import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';
import { Navigate } from 'react-router-dom';
import { ProtectedRoute } from '@/routes/common/ProtectedRoute';
// import SuspenseWrapper from the correct path or create the file if missing
import { SuspenseWrapper } from '@/routes/common/SuspenseWrapper';

const AdminAccountList = lazy(() => import('@/pages/admin-account/List'));
const AdminAccountCreate = lazy(() => import('@/pages/admin-account/Create'));
const AdminAccountEdit = lazy(() => import('@/pages/admin-account/Edit'));
const AdminAccountDetail = lazy(() => import('@/pages/admin-account/Detail'));

export const adminAccountRoutes: RouteObject = {
  path: 'admin-accounts',
  children: [
    {
      index: true,
      element: <Navigate to="list" replace />,
    },
    {
      path: 'list',
      element: (
        <ProtectedRoute pageKey="page:admin-accounts:list">
          <SuspenseWrapper>
            <AdminAccountList />
          </SuspenseWrapper>
        </ProtectedRoute>
      ),
    },
    {
      path: 'create',
      element: (
        <ProtectedRoute pageKey="page:admin-accounts:create">
          <SuspenseWrapper>
            <AdminAccountCreate />
          </SuspenseWrapper>
        </ProtectedRoute>
      ),
    },
    {
      path: 'edit/:id',
      element: (
        <ProtectedRoute pageKey="page:admin-accounts:edit">
          <SuspenseWrapper>
            <AdminAccountEdit />
          </SuspenseWrapper>
        </ProtectedRoute>
      ),
    },
    {
      path: 'detail/:id',
      element: (
        <ProtectedRoute pageKey="page:admin-accounts:detail">
          <SuspenseWrapper>
            <AdminAccountDetail />
          </SuspenseWrapper>
        </ProtectedRoute>
      ),
    },
  ],
};

